import axios from 'axios'
import { useState, useEffect } from 'react';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import ToastNotification from '../../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";
import Select from "react-select";

function Schedule() {

  const [showForm, setShowForm] = useState(false);
   const [chargeMaster, setChargeMaster] = useState([]);
   const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);


 
 const [form, setForm] = useState({
    schedule_name: '',
    title: '',
    type:''
  })


  const typeOptions = [
  { value: "source_of_fund", label: "Source of Fund" },
  { value: "use_of_fund", label: "Use of Fund" },
  { value: "mis_expenses", label: "MIS Expenses" },
  { value: "investment", label: "Investment" },
  { value: "current_assets", label: "Current Assets" },
  { value: "current_liabilities", label: "Current Liabilities" },
  { value: "provision", label: "Provision" }
];


  const [searchTerm, setSearchTerm] = useState('');

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };

  const handleAddClick = () => {
    setShowForm(true);
  };



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();


    if (isEditMode) {
      const sendData = new FormData();

      sendData.append(" schedule_name", form. schedule_name);
      sendData.append(" title", form. title);
      sendData.append("type", form.type);


      try {
        const res = await axios.put(
          `https://api.skyguard.group/api/update-schedule/${form.id}`,
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );


        showToast('Schedule Updated Successfully!', 'success');
        setShowForm(false);
       fetchSchedule();

        setForm({
          type: '',
           title: '',
           schedule_name:''
        
        })
      } catch (err) {
        showToast('Fail To Update Charge Type!', 'danger');
        console.error("❌ Error:", err.response?.data || err.message);
      }
    } else {
      const sendData = new FormData();

      sendData.append(" schedule_name", form.schedule_name);
      sendData.append(" title", form.title);
    sendData.append(" type", form.type);


      try {
        const res = await axios.post(
          "https://api.skyguard.group/api/add-schedule",
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );


        showToast('Schedule Added successfully!', 'success');
        setShowForm(false);
          fetchSchedule();

        setForm({
          schedule_name: '',
           title: '',
           type:''
       
        })
      } catch (err) {
        showToast('Fail to add Schedule!', 'danger');
        console.error("❌ Error:", err.response?.data || err.message);
      }
    }

  };
  
  
    const fetchSchedule = async () => {

    try {
      const resParty = await axios.get('https://api.skyguard.group/api/fetch-schedule');
     setChargeMaster(resParty.data);
    } catch (error) {
      console.log(error)
    }
  };

  useEffect(() => {

   fetchSchedule();
  }, []);

    const handleEdit = (form) => {

    setForm({
      id: form.id || '',
      schedule_name: form.schedule_name || '',
       title: form. title || '',
       type:form.type || ""
   
    });
    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowForm(true);
  };

    const filteredData = chargeMaster.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  )

  return (
  <>
  
      <div className='main-section'>
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <ToastNotification
            show={toast.show}
            message={toast.message}
            bg={toast.bg}
            onClose={() => setToast({ ...toast, show: false })}
          />
          <h3 className='my-3 fw-bold fs-5 golos'>Schedule Name</h3>



          <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">

            <div className="mb-2 w-50 w-md-50 pe-md-2">
              <input
                className="form-control w-100"
                list="datalistOptions"
                placeholder="Search by Name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="mb-2">
              <button className="btn btn-success" onClick={handleAddClick}>
                <AiOutlinePlusCircle size={20} /> Add
              </button>
            </div>
          </div>


          {showForm && (


            <div className='card p-3 mb-3  w-75 mx-auto'>
              <form onSubmit={handleSubmit} >

                      {isEditMode && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {form.schedule_name}
    </span>
  </div>
)}

                <hr />

                <div className='row g-3'>

                  <div className="col-md-6">
                    <label htmlFor='name' className="form-label fw-medium" > Name </label>
                    <input type="text" className="form-control" name="schedule_name" placeholder="Enter here..." 
                    value={form.schedule_name} onChange={handleInputChange} required />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor='middle' className="form-label fw-medium" >Title </label>
                    <input type="text" className="form-control" name="title" placeholder="Enter here..."
                      value={form.title}
                      onChange={handleInputChange}

                    />
                  </div>

   <div className="col-md-6">

  <label className="form-label fw-medium">
    Type
  </label>

  <Select
    options={typeOptions}

    value={
      typeOptions.find(
        (opt) => opt.value === form.type
      ) || null
    }

    onChange={(selected) =>
      setForm((prev) => ({
        ...prev,
        type: selected ? selected.value : ""
      }))
    }

    placeholder="Select Type"
    isClearable
  />

</div>


                  <div className='gap-2 d-flex justify-content-center mt-4'>



                    <button type="submit" className='btn btn-success w-10'>
                      {isEditMode ? "Update" : "Save"}
                    </button>
                    <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                      setShowForm(false);
                      setIsEditMode(false);
                      setForm({
                        schedule_name: '',
                         title: '',
                   
                      })
                    }}>
                      Cancel
                    </button>
                  </div>

                </div>
              </form>
            </div>
          )}




          <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            <table className='table table-bordered table-striped table-hover text-center align-middle'>

              <thead className='table-info'>
                <tr>
                   <th scope='col'>SN</th>
                              <th scope='col'>Action</th>
                 
                  <th scope='col'>Schedule Name</th>
                  <th scope='col'>Title</th>
               
            
      
                </tr>
              </thead>
              <tbody>
                {filteredData.map((acc, idx) => (
                <tr key={idx} >
                     <td>{idx + 1}</td>
                    <td>  <button
                    className="btn btn-success"
                   
                    onClick={() => handleEdit(acc)}
                  >
                    <CiEdit size={20} />
                  </button>
                  </td>

               
                  <td> {acc.schedule_name} </td>
                  <td> {acc.title}  </td>
                
              
                
                </tr>


              ))}
              </tbody>
            </table>
          </div>



        
        </div>
      </div>
  </>
  )
}

export default Schedule